











import Vue from "vue";

interface CComputed {
  callback: string;
  logo: string;
}

export default Vue.extend<{}, {}, CComputed, {}>({
  name: "BackButton",
  computed: {
    callback() {
      return this.$store.state.callback.url;
    },
    logo() {
      return this.$store.state.icons.logo;
    },
  },
});
